import React, { FC } from 'react';
import { Progress as BaseProgress, ProgressProps as BaseProgressProps } from 'antd';
import cx from 'classnames';

import { Override } from 'types/common';

import styles from './styles.module.css';

type ProgressProps = Override<BaseProgressProps, {
  percent: number;
}>

const Progress: FC<ProgressProps> = ({
  className,
  showInfo = false,
  ...props
}) => (
  <BaseProgress
    className={cx(styles.root, className)}
    showInfo={showInfo}
    {...props}
  />
);

export default Progress;
